// eslint-disable-next-line import/prefer-default-export
export const messages = {
  ja: {
    message: {
      // Errorメッセージ
      SIGNAGE001E: 'ただいまメンテナンス中です。時間を置いて再度お試し下さい。',
      SIGNAGE002E: 'アカウントIDもしくはパスワードが間違っています',
      SIGNAGE003E: '通信がオフラインです。インターネットに接続してから再度お試しください。',
      SIGNAGE004E:
        '現在システム側の処理に時間がかかっています。時間を置いてからブラウザのリロードボタンを押下して状態をご確認ください。',
      SIGNAGE005E: '予期せぬエラーが発生しました。再度発生する場合はお問い合わせください。',
      // Informationメッセージ
      SIGNAGE001I: 'ログアウトしますか?',
      SIGNAGE002I:
        'このメディアを削除しますか？このメディアを利用しているコンテンツや配信グループも同時に削除されます。',
      SIGNAGE003I:
        'このコンテンツを削除しますか？このコンテンツを利用している配信グループも同時に削除されます。',
      SIGNAGE004I: 'この配信グループを削除しますか？',
      SIGNAGE005I: 'コンテンツ編集の反映には<br>時間がかかる場合があります。',
      SIGNAGE006I:
        '配信グループを更新します。<br>しばらく経ってから(最大15分)<br>配信グループを確認してください。',
    },
  },
};
